import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import {getDirection, pexios} from '../../../utils/functions';

export default function ReportDescription({ report }) {
    const { t, i18n } = useTranslation();
    const { user } = useSelector((store) => store);

    const [descriptions, setDescriptions] = useState([]);
    const [descriptionText, setDescriptionText] = useState('');
    const [descriptionLoader, setDescriptionLoader] = useState(false);

    useEffect(() => {
        if (!report.id) return;
        setDescriptions(report?.accident?.description || []);
    }, [report]);

    function saveDescription() {
        if (!descriptionText) return;
        setDescriptionLoader(true);
        pexios('/api/v2/add-new-description', 'post', { id: report.accident.id, description: descriptionText ,type :'accident'})
            .then(res => {
                setDescriptions(prevState => ([
                    ...prevState,
                    res.data.data
                ]));
                setDescriptionText('');
                setDescriptionLoader(false);
            });
    }

    return (
        <div className='box'>
            <p className='title border-bottom pb5'> {t('Description')} </p>
            {
                user.type === 'expert' ?
                    <ul dir={getDirection(i18n.language) ==='rightToLeft'?'rtl': 'ltr'}>
                        {
                            descriptions.map(desc => (
                                <li key={desc.id}>
                                    <p>{ desc.description }</p>
                                </li>
                            ))
                        }
                    </ul> :
                    <p className='mt5 text-center text-sm'>{t('Leave us a message')}</p>

            }
            <div className='d-flex mt10 report-single-desc'>
                <div className='input-parent rtl flex1'>
                    <input
                        className='circle-right'
                        type='text'
                        placeholder={t('Description placeholder')}
                        style={{ backgroundColor: '#f2f3f4' }}
                        value={descriptionText}
                        onChange={e => setDescriptionText(e.target.value)}
                    />
                </div>
                <button className='btn btn-green btn-circle-left' disabled={descriptionLoader} onClick={saveDescription} >
                    {
                        descriptionLoader
                            ? <i className='fa fa-spinner fa-spin' />
                            : t('Save')
                    }
                </button>
            </div>
        </div>
    );
}
